import React, { useState, useEffect } from "react";
import { fetchPatientDocuments } from "../../services/firebase";

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "20px",
    maxWidth: "600px",
    width: "100%",
    maxHeight: "80vh",
    overflowY: "auto",
  },
  header: {
    marginBottom: "15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
    margin: 0,
  },
  closeButton: {
    padding: "6px 14px",
    backgroundColor: "#6c757d",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
  },
  list: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  documentItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px",
    border: "1px solid #e0e0e0",
    borderRadius: "6px",
    marginBottom: "8px",
  },
  documentLink: {
    color: "#007bff",
    textDecoration: "none",
    fontWeight: "500",
  },
  downloadButton: {
    padding: "6px 12px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "13px",
  },
  emptyState: {
    textAlign: "center",
    padding: "24px",
    color: "#666",
  },
  errorState: {
    textAlign: "center",
    padding: "24px",
    color: "#dc3545",
  },
};

const DocumentsModal = ({ isOpen, onClose, note }) => {
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Load every document for this patient, not just the ones on this note
  useEffect(() => {
    if (!isOpen || !note) return;
    let cancelled = false;
    setDocuments(Array.isArray(note.documents) ? note.documents : []);
    setIsLoading(true);
    fetchPatientDocuments(note)
      .then((docs) => {
        if (!cancelled) setDocuments(docs);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [isOpen, note]);

  if (!isOpen) return null;

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={modalStyles.header}>
          <h2 style={modalStyles.title}>
            Documents {note?.patient_name ? `– ${note.patient_name}` : ""}
          </h2>
          <button style={modalStyles.closeButton} onClick={onClose}>
            Close
          </button>
        </div>

        {isLoading && (
          <div style={modalStyles.emptyState}>Loading documents...</div>
        )}

        {!isLoading && documents.length === 0 ? (
          <div style={modalStyles.emptyState}>No documents uploaded for this patient.</div>
        ) : (
          <ul style={modalStyles.list}>
            {documents.map((doc) => (
              <li key={doc.id || doc.name || doc.url} style={modalStyles.documentItem}>
                <a
                  href={doc.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={modalStyles.documentLink}
                >
                  {doc.name}
                </a>
                <a
                  href={doc.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  download={doc.name}
                  style={modalStyles.downloadButton}
                >
                  Download
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default DocumentsModal;
